import { z } from 'zod';
import { toTranslationKey } from '../translation-key';

// Labels are expected to start each word with an uppercase letter.
export const normalizeLabel = (value: string) =>
  value
    .trim()
    .toLowerCase()
    .replace(
      /(^|[\s-])(\p{L})/gu,
      (_, separator, letter) => `${separator}${letter.toUpperCase()}`,
    );

// Names: letters, numbers and spaces; no hyphens or other punctuation.
const namePattern = /^[\p{L}\p{N}]+(?: [\p{L}\p{N}]+)*$/u;
// Allowed values: letters, numbers, spaces and hyphens; no other punctuation.
const allowedValuePattern = /^[\p{L}\p{N}]+(?:[ -][\p{L}\p{N}]+)*$/u;

export const searchAttributeFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'Name is required')
    .max(100, 'Name must be 100 characters or fewer')
    .regex(
      namePattern,
      'Only letters, numbers and spaces are allowed',
    ),
  productLines: z
    .array(z.string())
    .min(1, 'At least one product line is required'),
  allowedValues: z
    .array(
      z
        .string()
        .trim()
        .regex(
          allowedValuePattern,
          'Only letters, numbers, spaces and hyphens are allowed',
        ),
    )
    .min(1, 'At least one allowed filter value is required')
    .refine(
      (values) => new Set(values.map(toTranslationKey)).size === values.length,
      'Duplicate values are not allowed',
    ),
});

export type SearchAttributeFormValues = z.input<
  typeof searchAttributeFormSchema
>;
